import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  messages: [],
  messagesPagination: null,
  activeUser: null,
  groupMessages: [],
  groupMessagesPagination: null,
  activeGroupId: null,
};

const messageSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    setMessage: (state, action) => {
      state.messages = action.payload;
    },
    setMessagesPagination: (state, action) => {
      state.messagesPagination = action.payload;
    },
    setActiveUser: (state, action) => {
      state.activeUser = action.payload;
    },
    appendMessage: (state, action) => {
      const newMessage = action.payload;
      if (String(state?.activeUser?.id) === String(newMessage?.contact_id)) {
        state.messages.push(newMessage);
      }

      if (state?.activeGroupId && String(state.activeGroupId) === String(newMessage?.group_id)) {
        const exists = state.groupMessages.some(
          (msg) =>
            msg.group_batch_id === newMessage.group_batch_id
        );

        if (!exists) {
          state.groupMessages.push(newMessage);
        }
      }
    },
    removeTempMessage: (state, action) => {
      state.messages = state.messages.filter((msg) => msg?.sending !== true);
      state.groupMessages = state.groupMessages.filter((msg) => msg?.sending !== true);
    },
    setGroupMessages: (state, action) => {
      state.groupMessages = action.payload;
    },
    setGroupMessagesPagination: (state, action) => {
      state.groupMessagesPagination = action.payload;
    },
    setActiveGroupId: (state, action) => {
      state.activeGroupId = action.payload;
    },
  },
});

export const { setMessage, setMessagesPagination, setActiveUser, appendMessage, setGroupMessages, setGroupMessagesPagination, setActiveGroupId, removeTempMessage } =
  messageSlice.actions;

export default messageSlice.reducer;
